import { PageBlueprint, createFrontendPlugin } from '@backstage/frontend-plugin-api';
import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined';
import React from 'react';

const homeIcon = React.createElement(HomeOutlinedIcon);

const homePage = PageBlueprint.make({
  params: {
    path: '/home',
    title: 'Home',
    icon: homeIcon,
    loader: () =>
      import('./HomePage').then(module =>
        React.createElement(module.HomePage),
      ),
  },
});

export const myralisHomePlugin = createFrontendPlugin({
  pluginId: 'myralis-home',
  title: 'Home',
  icon: homeIcon,
  extensions: [homePage],
});

